import App from 'app/app.js';
import 'app/directive/LtOrderSummaryCtrl.js';

function LtOrderSummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      isPayPalDataRefreshed: '=',
      isScrollable: '=',
      showTax: '='
    },
    template:
      '<div class="row" ng-init="orderSummary.init()"> ' +
      '    <div class="col-xs-12 order-summary"> ' +
      '        <h4 lt-translate="ORDER_SUMMARY_TITLE"></h4> ' +
      '        <ul class="items">' +
      '            <li class="sum-head sum-border">' +
      '                <span class="left" lt-translate="ORDER_SUMMARY_SUB_TITLE"></span>' +
      '                <span class="right" lt-translate="ORDER_SUMMARY_PRICE_TITLE"></span>' +
      '            </li>' +
      '            <li class="item sum-border" ng-repeat="subject in orderSummary.itemsInCart" ng-class="{last: $last}"> ' +
      '                <b><span class="item left sum-head" ng-bind="subject.name | uppercase"></span></b><br/>' +
      '                <ul class="orders" ng-repeat="order in subject.order">' +
      '                    <li>' +
      '                        <span class="left" ng-bind="order.orderable | ItemDescFilter"></span>' +
      '                        <span class="right" ng-bind="order.orderable.unitPrice | CurrencyLocaleFilter"></span>' +
      '                    </li>' +
      '                    <ul ng-repeat="orderLineDetail in order.orderLineDetails">' +
      '                       <li ng-if="order.orderable.items">' +
      '                           <span ng-bind="orderLineDetail.item.nameDesc"></span>' +
      '                       </li>' +
      '                       <ul ng-repeat="orderLineItemSelection in orderLineDetail.item.orderLineItemSelections">' +
      '                           <li>' +
      '                               {{orderLineItemSelection.label}}: {{orderLineItemSelection.value}}' +
      '                           </li>' +
      '                       </ul>' +
      '                   </ul>' +
      '                </ul>' +
      '            </li>' +
      '        </ul> ' +
      '        <ul class="titles">' +
      '            <li>' +
      '                <span class="left" lt-translate="ORDER_SUMMARY_SUBTOTAL" lt-translate-values="{itemCount: orderSummary.itemCount}"></span>' +
      '                <span class="right" ng-bind="orderSummary.getCartSubTotal() | CurrencyLocaleFilter"></span> ' +
      '            </li> ' +
      '            <li ng-show="orderSummary.getCartPromotionAmount() > 0"> ' +
      '                <span class="left" lt-translate="ORDER_SUMMARY_PROMOTION_TEXT"></span> ' +
      '                <span class="right" lt-translate="ORDER_SUMMARY_PROMOTION_VALUE" lt-translate-values="{promotionAmount: (orderSummary.getCartPromotionAmount() | CurrencyLocaleFilter)}"></span>' +
      '            </li> ' +
      '            <li> ' +
      '                <span class="left" lt-translate="ORDER_SUMMARY_SHIPPING_TEXT"></span> ' +
      '                <span class="right" ng-bind="orderSummary.getCartShippingPrice() | CurrencyLocaleFilter"></span> ' +
      '            </li> ' +
      '            <li ng-show="orderSummary.getCartTax() > 0 && showTax"> ' +
      '                <span class="left" lt-translate="ORDER_SUMMARY_TAX_TEXT"></span> ' +
      '                <span class="right" ng-bind="orderSummary.getCartTax() | CurrencyLocaleFilter"></span> ' +
      '            </li> ' +
      '            <li> ' +
      '                <span class="left total-text-size" lt-translate="ORDER_SUMMARY_CARTTOTAL"></span> ' +
      '                <b><span class="right total-text-size" ng-bind="orderSummary.getCartTotal() | CurrencyLocaleFilter"></span></b> ' +
      '            </li> ' +
      '        </ul> ' +
      '    </div> ' +
      '</div> ' +
      '<div class="row"> ' +
      '    <div class="col-xs-12"> ' +
      '        <div class="tax-included-line" ng-show="((orderSummary.payment.billingAddress.stateProvince || orderSummary.shippingAddress.stateProvince) && orderSummary.getCartTotal() > 0 && orderSummary.getCartTax() <= 0) && !orderSummary.isSimplePayOnly()" lt-translate="ORDER_SUMMARY_TAX_INCLUDED_WHERE_APPLICABLE"></div> ' +
      '    </div> ' +
      '</div> ' +
      '<div class="row"> ' +
      '    <div class="col-xs-12"> ' +
      '        <a class="right inline-link-blue" ng-click="orderSummary.goToShoppingCart()" lt-translate="GO_TO_SHOPPING_CART"></a> ' +
      '    </div> ' +
      '</div> ',
    controller: 'LtOrderSummaryCtrl',
    controllerAs: 'orderSummary'
  };
}

App.directive('ltOrderSummary', [LtOrderSummaryDirective]);
